import { Injectable } from '@angular/core';
import { SessionStorageService, StateService } from '../../../../../../core';
import { isPeriodicidadeAnual, isPeriodicidadePeriodo, isPeriodicidadeSemestral, isPeriodicidadeTrimestral } from '../../../../../../shared';
import { RepresentanteProdutividadeGeralKPITableState } from './representante-produtividade-geral-kpi-table.state';

@Injectable()
/** Service para gerenciamento do state do component de table dos KPIs de produtividade geral dos representantes */
export class RepresentanteProdutividadeGeralKPITableStateService extends StateService<RepresentanteProdutividadeGeralKPITableState> {
    constructor(sessionStorageService: SessionStorageService,) {
        super(
            sessionStorageService,
            {
                isShowAnual: false,
                isShowSemestral: false,
                isShowTrimestral: false
            }
        );
    }

    /** Seta a periodicidade */
    setPeriodicidade(periodicidade: number) {
        // TODO: OCULTANDO TEMPORÁRIAMENTE AS VISUALIZAÇÕES DE ANO, SEMESTRE E TRIMESTRE ATÉ QUE SEJA VERIFICADO A FORMA CORRETA DE CONTABILIZAR A CARTEIRA INATIVA POR ESTE PERÍDOS.
        // APÓS ISTO REMOVER ESTAS LINHAS ABAIXO!
        this.state.isShowAnual = false;
        this.state.isShowSemestral = false;
        this.state.isShowTrimestral = false;
        return;
        // Trimestral
        if (isPeriodicidadeTrimestral(periodicidade)) {
            this.state.isShowTrimestral = true;
        }

        // Semestral
        if (isPeriodicidadeSemestral(periodicidade)) {
            this.state.isShowTrimestral = true;
            this.state.isShowSemestral = true;
        }

        // Anual
        if (isPeriodicidadeAnual(periodicidade)) {
            this.state.isShowTrimestral = true;
            this.state.isShowSemestral = true;
            this.state.isShowAnual = true;
        }

        // Período
        if (isPeriodicidadePeriodo(periodicidade)) {
            this.state.isShowTrimestral = true;
            this.state.isShowSemestral = true;
            this.state.isShowAnual = true;
        }

        this.propagateState();
    }
}
